import { useEffect, useState } from 'react'

declare const COMPILING_FOR_LGTV: boolean

const useGetExternalIP = () => {
  const [ip, setIp] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!COMPILING_FOR_LGTV) return

    async function fetchIp() {
      setLoading(true)
      try {
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()
        setIp(data.ip)
      } catch (error) {
        console.error('Error fetching IP:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchIp()
  }, [])

  return { ip, loading }
}

export default useGetExternalIP
